<template>
  <div v-if="isVisible">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    isVisible: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// NoData.vue?5a753dd3